
export enum ReduxActionType {
    LOGIN = 800000,                // 登錄
    USER,          // 用戶信息
}
